import { render, staticRenderFns } from "./toggle-searches.vue?vue&type=template&id=c8bace70&"
import script from "./toggle-searches.vue?vue&type=script&lang=js&"
export * from "./toggle-searches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports